const API_BASE_URL = "https://www.kftgcs.com/api";


export default API_BASE_URL;
